import angular from 'angular';
import uiRouter from 'angular-ui-router';
import editProfileComponent from './editProfile.component';
import accessRules from '../../_helpers/accessRules';

let editProfileModule = angular.module('editProfile', [
  uiRouter
])

.component('editProfile', editProfileComponent)
.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('main.editProfile', {
      name:'main.editProfile',
      url: '/editProfile',
      component: 'editProfile',
      data: {protected: true, rolesRequired: accessRules.EDIT_PROFILE},
      params: {id: undefined}
    });
})

.name;

export default editProfileModule;



// WEBPACK FOOTER //
// ./client/app/components/editProfile/editProfile.js